export default "__VITE_ASSET__BKdWoEth__"